import React from 'react';
import Icon from '../../../components/AppIcon';

const UpcomingActivities = ({ activities }) => {
  const getActivityIcon = (type) => {
    switch (type) {
      case 'scheduled':
        return 'Calendar';
      case 'mood-check':
        return 'Heart';
      case 'communication':
        return 'MessageCircle';
      default:
        return 'Clock';
    }
  };

  const getActivityColor = (type) => {
    switch (type) {
      case 'scheduled':
        return 'primary';
      case 'mood-check':
        return 'accent';
      case 'communication':
        return 'secondary';
      default:
        return 'muted';
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow?.setDate(tomorrow?.getDate() + 1);

    if (date?.toDateString() === today?.toDateString()) {
      return `Today at ${date?.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true })}`;
    } else if (date?.toDateString() === tomorrow?.toDateString()) {
      return `Tomorrow at ${date?.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true })}`;
    } else {
      return date?.toLocaleDateString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit', hour12: true });
    }
  };

  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-6 lg:p-8 shadow-therapeutic">
      <div className="flex items-center justify-between mb-4 md:mb-6">
        <h3 className="text-xl md:text-2xl lg:text-3xl font-heading font-semibold text-foreground">
          Upcoming Activities
        </h3>
        <span className="text-xs md:text-sm text-muted-foreground font-caption">
          Next 7 days
        </span>
      </div>
      <div className="space-y-3 md:space-y-4">
        {activities?.length === 0 ? (
          <div className="text-center py-8 md:py-12">
            <div className="flex items-center justify-center w-16 h-16 md:w-20 md:h-20 bg-muted/30 rounded-full mx-auto mb-3 md:mb-4">
              <Icon name="Calendar" size={32} color="var(--color-muted-foreground)" />
            </div>
            <p className="text-sm md:text-base text-muted-foreground">
              No upcoming activities scheduled
            </p>
          </div>
        ) : (
          activities?.map((activity) => (
            <div
              key={activity?.id}
              className="flex items-start gap-3 md:gap-4 p-3 md:p-4 bg-muted/30 rounded-lg border border-border hover:bg-muted/50 transition-therapeutic"
            >
              <div className={`flex-shrink-0 flex items-center justify-center w-10 h-10 md:w-12 md:h-12 bg-${getActivityColor(activity?.type)}/10 rounded-md`}>
                <Icon 
                  name={getActivityIcon(activity?.type)} 
                  size={20} 
                  color={`var(--color-${getActivityColor(activity?.type)})`} 
                />
              </div>

              <div className="flex-1 min-w-0">
                <h4 className="text-sm md:text-base lg:text-lg font-heading font-medium text-foreground mb-1">
                  {activity?.title}
                </h4>
                
                <p className="text-xs md:text-sm text-muted-foreground font-caption mb-2">
                  {activity?.description}
                </p>

                <div className="flex items-center gap-2 text-xs md:text-sm text-muted-foreground">
                  <Icon name="Clock" size={14} color="currentColor" />
                  <span>{formatDate(activity?.scheduledTime)}</span>
                </div>
              </div>

              {activity?.isConfirmed && (
                <div className="flex-shrink-0">
                  <div className="flex items-center gap-1 px-2 py-1 bg-success/10 text-success rounded text-xs font-medium">
                    <Icon name="Check" size={14} color="currentColor" />
                    <span>Confirmed</span>
                  </div>
                </div>
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default UpcomingActivities;